import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { HeroCatVideo } from './HeroCatVideo';
import { principles } from '../data/site';
export function Hero() {
  return <section id="top" data-id="element-35" data-mp="9ktcvkgndww6">
      <div className="bg-cream" data-id="element-36" data-mp="9ka2qpx8ocsp">
        <div className="mx-auto grid max-w-content grid-cols-1 items-center gap-8 px-5 pb-12 pt-10 sm:px-6 md:px-8 md:pb-16 md:pt-14 lg:grid-cols-2 lg:gap-12 lg:px-10 lg:pb-20 lg:pt-16" data-id="element-37" data-mp="9lbgj25n3de4">
          <div className="max-w-[560px]" data-id="element-38" data-mp="12860lxyjoar2">
            <h1 className="font-display text-[40px] font-semibold leading-[1.04] tracking-[-0.025em] text-ink sm:text-[56px] lg:text-[66px]" data-id="element-39" data-mp="1274n7mu23c66">
              Small studio.
              <br data-id="element-40" data-mp="s9qanyb977j5" />
              <span className="text-violet" data-id="element-41" data-mp="sddz4j1ud3r0">
                Big apps
                <span className="text-gold" data-id="element-42" data-mp="nbopn7u9oy51">.</span>
              </span>
            </h1>

            <p className="mt-7 max-w-lg text-[17px] leading-relaxed text-ink/75" data-id="element-43" data-mp="3d2bjxpolizvj">
              Black Comet Labs builds original apps for learning, life and play. A focused
              portfolio. High standards. Plenty of personality.
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-6" data-id="element-44" data-mp="3o7lq5lizewmb">
              <a href="#lab" className="inline-flex min-h-[52px] items-center gap-2 rounded-[2px] bg-violet px-7 text-[15px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-violet/85" data-id="element-45" data-mp="3o6u697yqynbv">
                Explore the lab
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-46" data-mp="30ggfdkrweuiv" />
              </a>
              <a href="#story" className="inline-flex min-h-[44px] items-center border-b border-ink/30 text-[15px] font-medium text-ink transition-colors duration-150 ease-out hover:border-ink" data-id="element-47" data-mp="359j6lm97drvw">
                The studio
              </a>
            </div>
          </div>

          <div className="w-full" data-id="element-48" data-mp="2hjym2yxeimki">
            <HeroCatVideo data-id="element-49" data-mp="2lkil681jc09a" />
          </div>
        </div>
      </div>

      <div className="bg-ink" data-id="element-50" data-mp="2lmuz8a469qh2">
        <dl className="mx-auto grid max-w-content grid-cols-1 gap-px bg-cream/15 sm:grid-cols-2 lg:grid-cols-4" data-id="element-51" data-mp="s1rt2qgj2avc">
          {principles.map(principle => <div key={principle.title} className="bg-ink px-5 py-9 md:px-8 lg:px-10" data-id="element-52" data-mp="na06er0hspah">
              <dt className="font-display text-[26px] font-medium leading-none text-cream md:text-[28px]" data-id="element-53" data-mp="icrn2n3lyf7n">
                {principle.title}
              </dt>
              <dd className="mt-3 text-[14px] leading-relaxed text-cream/60" data-id="element-54" data-mp="1b1fez1iv42u6">{principle.caption}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}